<h1 matDialogTitle>Order Details</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <!-- <mat-form-field fxFlex="100" width="100%">
        <mat-label>Truck Code</mat-label>
        <input matInput type="text" #alternateKey formControlName="alternateKey" maxlength="10"
          autocomplete="new-password">
        <mat-hint align="end">{{alternateKey.value.length}} / 10</mat-hint>
      </mat-form-field> -->

      <ng-container *ngIf="data.mode === 'SYSPRO'; else salesOrder">


        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Truck Code</mat-label>
          <mat-select formControlName="alternateKey">
            <mat-option *ngFor="let truck of trucks" [value]="truck.truckCode">
              {{truck.truckDesc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Customer PO Number</mat-label>
          <input matInput type="text" #customerPoNumber formControlName="customerPoNumber" maxlength="30"
            autocomplete="new-password">
          <mat-hint align="end">{{customerPoNumber.value.length}} / 30</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Shipping Instructions</mat-label>
          <input matInput type="text" #shippingInstrs formControlName="shippingInstrs" maxlength="50"
            autocomplete="new-password">
          <mat-hint align="end">{{shippingInstrs.value.length}} / 50</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Special Instructions</mat-label>
          <input matInput type="text" #specialInstrs formControlName="specialInstrs" maxlength="30"
            autocomplete="new-password">
          <mat-hint align="end">{{specialInstrs.value.length}} / 30</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="50" width="100%">
          <mat-label>Requested Ship Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="requestedShipDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex="50" width="100%">
          <mat-label>Delayed Delivery Date</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="delayedDeliveryDat">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

      </ng-container>

      <ng-template #salesOrder>
        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Special Instructions</mat-label>
          <input matInput type="text" #specialInstrs formControlName="specialInstrs" maxlength="30"
            autocomplete="new-password">
          <mat-hint align="end">{{specialInstrs.value.length}} / 30</mat-hint>
        </mat-form-field>
      </ng-template>


    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
</mat-dialog-actions>